import React, { useState, useEffect } from 'react'
import { DataTable, Button } from '@paypalcorp/pp-react'
import { TextInputWrapper } from '../components/pp-react-wrappers'
import Fuse from 'fuse.js'

const nonMaestroAVSErrorRows = [
  {
    id: 'row1',
    code: {
      value: <code>A</code>,
    },
    meaning: {
      value: 'Address',
    },
    matchedDetails: {
      value: 'Address only (no ZIP code)',
    },
  },
  {
    id: 'row2',
    code: {
      value: <code>B</code>,
    },
    meaning: {
      value: 'International "A"',
    },
    matchedDetails: {
      value: 'Address only (no ZIP code)',
    },
  },
  {
    id: 'row3',
    code: {
      value: <code>C</code>,
    },
    meaning: {
      value: 'International "N"',
    },
    matchedDetails: {
      value: 'None. The transaction is declined.',
    },
  },
  {
    id: 'row4',
    code: {
      value: <code>D</code>,
    },
    meaning: {
      value: 'International "X"',
    },
    matchedDetails: {
      value: 'Address and Postal Code',
    },
  },
  {
    id: 'row5',
    code: {
      value: <code>E</code>,
    },
    meaning: {
      value: 'Not allowed for MOTO (Internet/Phone) transactions',
    },
    matchedDetails: {
      value: 'Not applicable. The transaction is declined.',
    },
  },
  {
    id: 'row6',
    code: {
      value: <code>F</code>,
    },
    meaning: {
      value: 'UK-specific "X"',
    },
    matchedDetails: {
      value: 'Address and Postal Code',
    },
  },
  {
    id: 'row7',
    code: {
      value: <code>G</code>,
    },
    meaning: {
      value: 'Global Unavailable',
    },
    matchedDetails: {
      value: 'Not applicable',
    },
  },
  {
    id: 'row8',
    code: {
      value: <code>I</code>,
    },
    meaning: {
      value: 'International Unavailable',
    },
    matchedDetails: {
      value: 'Not applicable',
    },
  },
  {
    id: 'row9',
    code: {
      value: <code>M</code>,
    },
    meaning: {
      value: 'Address',
    },
    matchedDetails: {
      value: 'Address and Postal Code',
    },
  },
  {
    id: 'row10',
    code: {
      value: <code>N</code>,
    },
    meaning: {
      value: 'No',
    },
    matchedDetails: {
      value: 'None. The transaction is declined.',
    },
  },
  {
    id: 'row11',
    code: {
      value: <code>P</code>,
    },
    meaning: {
      value: 'Postal (International "Z")',
    },
    matchedDetails: {
      value: 'Postal Code only (no Address)',
    },
  },
  {
    id: 'row12',
    code: {
      value: <code>R</code>,
    },
    meaning: {
      value: 'Retry',
    },
    matchedDetails: {
      value: 'Not applicable',
    },
  },
  {
    id: 'row13',
    code: {
      value: <code>S</code>,
    },
    meaning: {
      value: 'Service not Supported',
    },
    matchedDetails: {
      value: 'Not applicable',
    },
  },
  {
    id: 'row14',
    code: {
      value: <code>U</code>,
    },
    meaning: {
      value: 'Unavailable',
    },
    matchedDetails: {
      value: 'Not applicable',
    },
  },
  {
    id: 'row15',
    code: {
      value: <code>W</code>,
    },
    meaning: {
      value: 'Whole ZIP',
    },
    matchedDetails: {
      value: 'Nine-digit ZIP code (no Address)',
    },
  },
  {
    id: 'row16',
    code: {
      value: <code>X</code>,
    },
    meaning: {
      value: 'Exact match',
    },
    matchedDetails: {
      value: 'Address and nine-digit ZIP code',
    },
  },
  {
    id: 'row17',
    code: {
      value: <code>Y</code>,
    },
    meaning: {
      value: 'Yes',
    },
    matchedDetails: {
      value: 'Address and five-digit ZIP',
    },
  },
  {
    id: 'row18',
    code: {
      value: <code>Z</code>,
    },
    meaning: {
      value: 'ZIP',
    },
    matchedDetails: {
      value: 'Five-digit ZIP code (no Address)',
    },
  },
  {
    id: 'row19',
    code: {
      value: 'All others',
    },
    meaning: {
      value: 'Error',
    },
    matchedDetails: {
      value: 'Not applicable',
    },
  },
]

const nonMaestroCVVErrorRows = [
  {
    id: 'row1',
    code: {
      value: <code>E</code>,
    },
    meaning: {
      value: 'Error - Unrecognized or Unknown response',
    },
    matchedDetails: {
      value: 'Not applicable',
    },
  },
  {
    id: 'row2',
    code: {
      value: <code>I</code>,
    },
    meaning: {
      value: 'Invalid or Null',
    },
    matchedDetails: {
      value: 'Not applicable',
    },
  },
  {
    id: 'row3',
    code: {
      value: <code>M</code>,
    },
    meaning: {
      value: 'Match',
    },
    matchedDetails: {
      value: 'or CSC',
    },
  },
  {
    id: 'row4',
    code: {
      value: <code>N</code>,
    },
    meaning: {
      value: 'No match',
    },
    matchedDetails: {
      value: 'None',
    },
  },
  {
    id: 'row5',
    code: {
      value: <code>P</code>,
    },
    meaning: {
      value: 'Not processed',
    },
    matchedDetails: {
      value: 'Not applicable',
    },
  },
  {
    id: 'row6',
    code: {
      value: <code>S</code>,
    },
    meaning: {
      value: 'Service not supported',
    },
    matchedDetails: {
      value: 'Not applicable',
    },
  },
  {
    id: 'row7',
    code: {
      value: <code>U</code>,
    },
    meaning: {
      value: 'Unknown - Issuer is not certified',
    },
    matchedDetails: {
      value: 'Not applicable',
    },
  },
  {
    id: 'row8',
    code: {
      value: <code>X</code>,
    },
    meaning: {
      value: 'No response',
    },
    matchedDetails: {
      value: 'Not applicable',
    },
  },
  {
    id: 'row9',
    code: {
      value: 'All others',
    },
    meaning: {
      value: 'Error',
    },
    matchedDetails: {
      value: 'Not applicable',
    },
  },
]

const maestroAVSErrorRows = [
  {
    id: 'row1',
    code: {
      value: <code>0</code>,
    },
    meaning: {
      value: 'All the address information matched.',
    },
    matchedDetails: {
      value: 'All information matched',
    },
  },
  {
    id: 'row2',
    code: {
      value: <code>1</code>,
    },
    meaning: {
      value: 'None of the address information matched.',
    },
    matchedDetails: {
      value: 'None. The transaction is declined.',
    },
  },
  {
    id: 'row3',
    code: {
      value: <code>2</code>,
    },
    meaning: {
      value: 'Part of the address information matched.',
    },
    matchedDetails: {
      value: 'Partial',
    },
  },
  {
    id: 'row4',
    code: {
      value: <code>3</code>,
    },
    meaning: {
      value: 'The merchant did not provide AVS information. Not processed.',
    },
    matchedDetails: {
      value: 'Not applicable',
    },
  },
  {
    id: 'row5',
    code: {
      value: (
        <span>
          <code>4</code>, <code>U</code>. Either a number or a letter is
          returned.
        </span>
      ),
    },
    meaning: {
      value:
        'Address not checked, or acquirer had no response. Service not available.',
    },
    matchedDetails: {
      value: 'Not applicable',
    },
  },
  {
    id: 'row6',
    code: {
      value: <code>Null</code>,
    },
    meaning: {
      value: 'No AVS response was obtained. Default value of field.',
    },
    matchedDetails: {
      value: 'Not applicable',
    },
  },
]

const maestroCVVErrorRows = [
  {
    id: 'row1',
    code: {
      value: <code>0</code>,
    },
    meaning: {
      value: 'Matched',
    },
    matchedDetails: {
      value: 'CVV2',
    },
  },
  {
    id: 'row2',
    code: {
      value: <code>1</code>,
    },
    meaning: {
      value: 'No match',
    },
    matchedDetails: {
      value: 'None',
    },
  },
  {
    id: 'row3',
    code: {
      value: <code>2</code>,
    },
    meaning: {
      value: 'The merchant has not implemented CVV2 code handling',
    },
    matchedDetails: {
      value: 'Not applicable',
    },
  },
  {
    id: 'row4',
    code: {
      value: <code>3</code>,
    },
    meaning: {
      value: 'Merchant has indicated that CVV2 is not present on card',
    },
    matchedDetails: {
      value: 'Not applicable',
    },
  },
  {
    id: 'row5',
    code: {
      value: (
        <span>
          <code>4</code>, <code>X</code>. Either a number or a letter
          isreturned.
        </span>
      ),
    },
    meaning: {
      value: 'Service not available',
    },
    matchedDetails: {
      value: 'Not applicable',
    },
  },
  {
    id: 'row6',
    code: {
      value: 'All others',
    },
    meaning: {
      value: 'Error',
    },
    matchedDetails: {
      value: 'Not applicable',
    },
  },
]

const cardFieldsEvents_Focus_Rows = [
  {
    id: 'row',
    property: {
      value: <code>selector</code>,
    },
    type: {
      value: 'string',
    },
    description: {
      value: (
        <span>
          A CSS selector to find the container where the card fields are
          inserted.
        </span>
      ),
    },
  },
  {
    id: 'row',
    property: {
      value: <code>placeholder</code>,
    },
    type: {
      value: 'string',
    },
    description: {
      value: (
        <span>
          Used as the <code>placeholder</code> attribute of the input. If the
          browser doesn't natively support<code>placeholder</code>, it is
          polyfilled.
        </span>
      ),
    },
  },
  {
    id: 'row',
    property: {
      value: <code>type</code>,
    },
    type: {
      value: 'string',
    },
    description: {
      value: (
        <span>
          The <code>type</code> attribute of the input. For example, to mask{' '}
          <code>CVV</code> input use <code>type: "password"</code>.
        </span>
      ),
    },
  },
  {
    id: 'row',
    property: {
      value: <code>formatInput</code>,
    },
    type: {
      value: 'boolean',
    },
    description: {
      value: (
        <span>
          Allow or deny automatic formatting on this field. Default is{' '}
          <code>true</code>.
        </span>
      ),
    },
  },
  {
    id: 'row',
    property: {
      value: <code>maskInput</code>,
    },
    type: {
      value: 'object or boolean',
    },
    description: {
      value: (
        <span>
          Allow or deny input masking when input is not focused. If set to{' '}
          <code>true</code>, instead of an object, the defaults for the{' '}
          <code>maskInput</code> parameters are used. Default is{' '}
          <code>false</code>. The object properties are: <br />
          <code>character</code>: A string field which specifies the character
          to use when masking the input. The default character ('•') uses a
          Unicode symbol, so the web page must support UTF-8 characters when
          using the default. <br /> <code>showLastFour</code>: A Boolean field
          applicable only for the credit card field. Defines whether to show the
          last 4 digits of the card when masking. Default is <code>false</code>.
        </span>
      ),
    },
  },
  {
    id: 'row',
    property: {
      value: <code>maxCardLength</code>,
    },
    type: {
      value: 'number',
    },
    description: {
      value: (
        <span>
          This option only applies to the <code>number</code> field. Limits the
          card number length, even if the card brand supports longer card
          numbers. If the value that is passed is greater than the max length
          for a card brand, the smaller of the two values is used. For example,
          if <code>maxCardLength</code> is set to 16, but an American Express
          card, which has a max card length of 15, is entered, the max card
          length is 15.
        </span>
      ),
    },
  },
  {
    id: 'row',
    property: {
      value: <code>maxlength</code>,
    },
    type: {
      value: 'number',
    },
    description: {
      value: (
        <span>
          This option applies only to the <code>cvv</code> field. Used as the{' '}
          <code>maxlength</code> attribute of the input if it is less than the
          default. The <code>maxlength</code> option is most often used to limit
          the length of the CVV input for CVV-only verifications when the card
          type is known, and to limit the length of the postal code input when
          cards are coming from a known region.
        </span>
      ),
    },
  },
  {
    id: 'row',
    property: {
      value: <code>minlength</code>,
    },
    type: {
      value: 'number',
    },
    description: {
      value: (
        <span>
          This option applies only to the <code>cvv</code> field. Used as the{' '}
          <code>minlength</code> attribute of the input. The default value is{' '}
          <code>3</code>. The <code>minlength</code> attribute applies only to
          integrations capturing a CVV without a <code>number</code> field.
        </span>
      ),
    },
  },
  {
    id: 'row',
    property: {
      value: <code>prefill</code>,
    },
    type: {
      value: 'string',
    },
    description: {
      value: (
        <span>
          A value to be used to pre-fill the field. For example, when creating
          an update card form, you can pre-fill the expiration date fields with
          the old expiration date.
        </span>
      ),
    },
  },
  {
    id: 'row',
    property: {
      value: <code>rejectUnsupportedCards</code>,
    },
    type: {
      value: 'boolean',
    },
    description: {
      value: (
        <span>
          Allow only card types that your merchant account can process.
          Unsupported card types invalidate the card form. For example, if you
          only process Visa cards, a payer entering an American Express card
          would get an invalid card field. This can be used only for the{' '}
          <code>number</code> field. The default is <code>false</code>.
        </span>
      ),
    },
  },
]

const avsErrorColumns = {
  code: {
    title: 'AVS Code',
    mobile: {
      placement: 'a12',
      width: 'auto',
    },
  },
  meaning: {
    title: 'Meaning',
    mobile: {
      placement: 'b3',
    },
  },
  matchedDetails: {
    title: 'Matched details',
    mobile: {
      placement: 'b3',
    },
  },
}

const cvv2ErrorColumns = {
  code: {
    title: 'CVV2 Code',
    mobile: {
      placement: 'a12',
      width: 'auto',
    },
  },
  meaning: {
    title: 'Meaning',
    mobile: {
      placement: 'b3',
    },
  },
  matchedDetails: {
    title: 'Matched details',
    mobile: {
      placement: 'b3',
    },
  },
}

const cardFieldsEvents_Focus_Columns = {
  property: {
    title: 'Property',
    mobile: {
      placement: 'a12',
      width: 'auto',
    },
  },
  type: {
    title: 'Type',
    mobile: {
      placement: 'b3',
    },
  },
  description: {
    title: 'Description',
    mobile: {
      placement: 'b3',
    },
  },
}

interface ISearchableTable {
  rowDataName: string
  colDataName: string
  searchKeys?: string[]
  searchable?: boolean
}

const lookupRow = {
  non_maestro_avs_error: nonMaestroAVSErrorRows,
  non_maestro_cvv_error: nonMaestroCVVErrorRows,
  maestro_avs_error: maestroAVSErrorRows,
  maestro_cvv_error: maestroCVVErrorRows,
  card_fields_events_focus_row: cardFieldsEvents_Focus_Rows,
}

const lookupCol = {
  avs_error: avsErrorColumns,
  cvv_error: cvv2ErrorColumns,
  card_fields_events_focus_col: cardFieldsEvents_Focus_Columns,
}

const SearchableTable = ({
  rowDataName,
  colDataName,
  searchKeys = [],
  searchable = false,
}: ISearchableTable) => {
  const allRows = lookupRow[rowDataName]
  const columns = lookupCol[colDataName]
  const [rows, setRows] = useState(allRows.slice(0, 5))
  const options = {
    threshold: 0.4,
    keys: searchKeys,
  }
  const fuse = new Fuse(allRows, options)
  const [isLoading, setLoading] = useState(false)
  const [searchInput, setSearchInput] = useState('')
  const showSeeMoreBtn = rows.length < allRows.length
  const [filteredRows, setFilteredRows] = useState([])

  useEffect(() => {
    if (searchInput) {
      setFilteredRows(fuse.search(searchInput).map(({ item }) => item))
    } else {
      setFilteredRows([])
    }
  }, [searchInput])

  const handleTextChange = (e) => {
    setSearchInput(e.target.value)
  }

  const handleSeeMore = () => {
    setSearchInput('')
    setLoading(true)
    setTimeout(() => {
      setRows((currRowsShown) => allRows.slice(0, currRowsShown.length + 5))
      setLoading(false)
    }, 300)
  }

  return (
    <>
      {searchable && (
        <TextInputWrapper
          nameValue="basic"
          errorPresent={false}
          errorTextForFpti=""
          name="basic"
          value={searchInput}
          label="Search table"
          labelClassName="test"
          onKeyUp={handleTextChange}
        />
      )}
      <DataTable
        data-testid="searchable-table"
        description="Basic"
        rows={searchInput ? filteredRows : rows}
        columns={columns}
        isLoading={isLoading}
        idPrefix="basic"
        scroll
        style={{ maxHeight: '36rem', marginTop: '1.5rem' }}
      />
      {showSeeMoreBtn && (
        <div className="table-btnWrapper" data-testid="btn-see-more">
          <Button onClick={handleSeeMore} size="sm" secondary>
            See more
          </Button>
        </div>
      )}
    </>
  )
}

export default SearchableTable
